import loadable from '@loadable/component';
import './styles/chatbot.css';
import './styles/bootstrap.min.css';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

function App() {
  const Home = loadable(()=>import('./components/Home/index'))
  const Chatbot = loadable(()=>import('./components/Chatbot/index'))
  return (
    <div >
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Suspense>
      <div>
        {/* <Chatbot/> */}
      </div>
    </div>
  );
}

export default App;
